export const OFFSET_COMMON_HEIGHT = 50;